module.exports = __webpack_public_path__ + "static/media/cef.81b45b18.png";